<template>
  <div
    v-if="pageLoading"
    style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.6); z-index: 9999; justify-content: center; align-items: center;"
  >
    <div>
      <div>
        <h3 v-if="pageLoading">{{ message }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        pageLoading: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: "Loading..."
        }
    }
};
</script>

<style></style>
